/* Iron+Steel v3 section behaviour: hero slider and scroll rails. */

(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- <is-hero>: crossfade slider, dots, autoplay ---------- */
  if (!customElements.get('is-hero')) {
    class ISHero extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.delay = (parseInt(this.dataset.autoplay, 10) || 0) * 1000;

        this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i); this.restart(); }));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) this.start(); });
        this.onVisibility = () => (document.hidden ? this.stop() : this.start());
        document.addEventListener('visibilitychange', this.onVisibility);

        this.go(0);
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      go(i) {
        if (!this.slides.length) return;
        this.index = (i + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, n) => {
          const active = n === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.toggleAttribute('inert', !active);
        });
        this.dots.forEach((dot, n) => dot.setAttribute('aria-current', n === this.index ? 'true' : 'false'));
      }

      start() {
        if (!this.delay || this.slides.length < 2 || reduceMotion.matches || this.timer) return;
        this.timer = setInterval(() => this.go(this.index + 1), this.delay);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        this.stop();
        this.start();
      }
    }
    customElements.define('is-hero', ISHero);
  }

  /* ---------- <is-rail-controls>: prev/next scroll a sibling rail by two cards ---------- */
  if (!customElements.get('is-rail-controls')) {
    class ISRailControls extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-rail-dir]').forEach((btn) => {
          btn.addEventListener('click', () => this.scroll(parseInt(btn.dataset.railDir, 10)));
        });
      }

      scroll(dir) {
        const rail = document.getElementById(this.getAttribute('for'));
        if (!rail) return;
        const card = rail.firstElementChild;
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 20;
        const step = card ? card.offsetWidth + gap : 260;
        const max = rail.scrollWidth - rail.clientWidth;
        const left = Math.max(0, Math.min(max, rail.scrollLeft + dir * step * 2));
        rail.scrollTo({left, behavior: reduceMotion.matches ? 'auto' : 'smooth'});
      }
    }
    customElements.define('is-rail-controls', ISRailControls);
  }
})();
